import React from 'react';

interface ProjetProgressBarProps {
  pourcentage: number;
  label?: string;
  color?: string;
  height?: string;
}

const ProjetProgressBar: React.FC<ProjetProgressBarProps> = ({
  pourcentage,
  label,
  color = 'bg-violet-600',
  height = 'h-3',
}) => {
  const clampedPct = Math.min(100, Math.max(0, pourcentage));

  return (
    <div>
      {label && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-sm text-gray-500">{label}</span>
          <span className="text-sm font-semibold text-gray-900">{clampedPct}%</span>
        </div>
      )}
      <div className={`w-full bg-gray-200 rounded-full ${height} overflow-hidden`}>
        <div
          className={`${color} ${height} rounded-full transition-all duration-500`}
          style={{ width: `${clampedPct}%` }}
        />
      </div>
    </div>
  );
};

export default ProjetProgressBar;
